import { useState } from "react";
import "./PlanDownloadPopup.scss";
import WizardModal from "./wizard/WizardModal";
import PlanDownloadContentPicker from "../plan-download/PlanDownloadContentPicker";

export default function PlanDownloadModal({
	open,
	setOpen,
	template,
	idOrganization,
	idPlan,
	statuses = [],
	presets = [],
	templateId,
}) {
	const [loading, setLoading] = useState(false);

	return (
		<WizardModal
			open={open}
			setOpen={setOpen}
			disableClose={loading}
			className="plan_download_popup"
		>
			<PlanDownloadContentPicker
				open={open}
				template={template}
				onStart={() => setLoading(true)}
				onFinish={() => {
					setLoading(false);
					setOpen(false);
				}}
				statuses={statuses}
				presets={presets}
				presetOrganizationId={idOrganization}
				selectedOrganizationsPlans={[
					{ organization_id: idOrganization, organization_plan_id: idPlan },
				]}
				stepConfiguration={{
					approvals: {
						description:
							"Se non vengono selezionate adozioni, verrà inserita automaticamente l’ultima adozione avvenuta, se presente.",
						showSelection: true,
					},
				}}
				templateId={templateId}
			/>
		</WizardModal>
	);
}
